import { render, staticRenderFns } from "./BlockSelect.vue?vue&type=template&id=4e37500f&scoped=true&"
import script from "./BlockSelect.vue?vue&type=script&lang=js&"
export * from "./BlockSelect.vue?vue&type=script&lang=js&"
import style0 from "./BlockSelect.vue?vue&type=style&index=0&id=4e37500f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e37500f",
  null
  
)

export default component.exports